import { ThreeView } from "./View3dWebCad";
import * as THREE from 'three';
import { RayIntersection } from "./Octree/RayIntersection";
import { webcadDefines } from '../webcad';

export class SelectManager {

    public handlers: any[];
    private rayCaster: THREE.Raycaster;

    constructor() {
        this.rayCaster = new THREE.Raycaster();
        this.addEvent();
    }

    public invalidate = false;      //　機能無効化フラグ

    // イベントの付与
    private addEvent() {
        const element = ThreeView.get().container;

        const addHandler = (e: string, func)  => {
            element.addEventListener(e, func);
            return () => element.removeEventListener(e, func);
        }

        this.handlers = [
            addHandler('pointermove', e => this.move(e)),
            addHandler('pointerdown', e => this.down(e)),
            addHandler('pointerup', e => this.up(e))
        ];
    }

    // イベント削除
    public reset() {
        this.handlers.forEach(handler => handler());

        if (ThreeView.get().ItemDragManager != null) {
            ThreeView.get().ItemDragManager.reset();
        }

        if (ThreeView.get().ObjectSelectManager != null) {
            ThreeView.get().ObjectSelectManager.reset();
        }
    }

    public hitObjects(e): THREE.Intersection[] {
        this.rayCaster.setFromCamera(this.pointer(e), ThreeView.get().wcCameras.camera.me);
        const intersections = new RayIntersection(this.rayCaster);
        return intersections.getTargets_(ThreeView.get().CameraTarget.box3Status);
    }

    private down(e) {

        if (this.invalidate) return;

        const hitObj = this.hitObjects(e);
        // アイテム選択
        ThreeView.get().ItemDragManager.down(hitObj);
        // 壁選択
        ThreeView.get().ObjectSelectManager.down();
    }

    private move(e) {

        if (this.invalidate) return;

        const hitObj = this.hitObjects(e);
        // アイテム選択
        ThreeView.get().ItemDragManager.move(hitObj);
        // 壁選択
        ThreeView.get().ObjectSelectManager.move();
    }

    private up(e) {

        if (this.invalidate) return;

        
        const hitObj = this.hitObjects(e);
        // アイテム選択
        ThreeView.get().ItemDragManager.up();
        // 壁選択
        ThreeView.get().ObjectSelectManager.up(hitObj);
    }

    private pointer(e: MouseEvent) {
        const element = e.currentTarget as HTMLElement;
        // canvas要素上のXY座標
        // canvas要素の幅・高さ
        const rect = element.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const w = rect.width;
        const h = rect.height;

        // -1〜+1の範囲で現在のマウス座標を登録する
        const pointer = new THREE.Vector2();
        pointer.x = (x / w) * 2 - 1;
        pointer.y = -(y / h) * 2 + 1;
        return pointer;
    }

    // private ModelType = (obj: THREE.Object3D) => {
    //     if (obj.userData.modelInfo == null) return undefined;
    //     return obj.userData.modelInfo.typeExtras
    // };

    // // 家具
    // public isFurniture = (obj: THREE.Object3D) => this.ModelType(obj) == webcadDefines.ExtrasType.FUR;
    // // 住設
    // public isEquipment = (obj: THREE.Object3D) => this.ModelType(obj) == webcadDefines.ExtrasType.EQU;
    // // 外構
    // public isExterior = (obj: THREE.Object3D) => this.ModelType(obj) == webcadDefines.ExtrasType.EXT;

    // public isFitting = (obj: THREE.Object3D) => {
    //     const type = this.ModelType(obj);
    //     return type == webcadDefines.ExtrasType.DOOR
    //         || type == webcadDefines.ExtrasType.WIN
    //         || type == webcadDefines.ExtrasType.SHUTTER;
    // }

    // //天井照明
    // public isCeillingLight = (obj: THREE.Object3D) => this.ModelType(obj) == webcadDefines.ExtrasType.LIGHT;

    // // 壁
    // public isWall = (obj: THREE.Object3D) => obj.userData.type && obj.userData.type == webcadDefines.ExtrasType.KABE;
    // // 腰壁
    // public isKosiWall = (obj: THREE.Object3D) => obj.userData.type && obj.userData.type == webcadDefines.ExtrasType.KOSI;

    // // 内壁
    // public isInnerWall = (obj: THREE.Object3D) => obj.userData.sub_type && obj.userData.sub_type == webcadDefines.ExtrasSubType.INNERWALL;

    // // 天井
    // public isCeiling = (obj: THREE.Object3D) => obj.userData.sub_type && obj.userData.sub_type == webcadDefines.ExtrasType.CEILING;
    // public isCeiling_ = (obj: THREE.Object3D) => obj.userData.sub_type && obj.userData.sub_type == webcadDefines.ExtrasSubType.CEILING;

    // // 床
    // public isFloor = (obj: THREE.Object3D) => obj.userData.sub_type && obj.userData.sub_type == webcadDefines.ExtrasType.FLOOR;
    // public isFloor_ = (obj: THREE.Object3D) => obj.userData.sub_type && obj.userData.sub_type == webcadDefines.ExtrasSubType.FLOOR;

    // //見積もりリスト選択用
    // // 床
    // public isFloorFloor = (obj: THREE.Object3D) => {
    //     const data = obj.userData;
    //     return data.type && data.type == webcadDefines.ExtrasType.FLOOR && data && data.sub_type == webcadDefines.ExtrasSubType.FLOOR;
    // }
    // // 土間
    // public isFloorEntrance = (obj: THREE.Object3D) => {
    //     const data = obj.userData;
    //     return data.type && data.type == webcadDefines.ExtrasType.FLOOR && data && data.sub_type == webcadDefines.ExtrasSubType.ENTRANCE;
    // }
    
    // public isMitumoriFloor = (obj: THREE.Object3D) => {
    //     return this.isFloorFloor(obj) || this.isFloorEntrance(obj);
    // }

    // // -
    
    // // 敷地
    // public isSite = (obj: THREE.Object3D) => {
    //     return obj.userData.type && obj.userData.type == webcadDefines.ExtrasType.GROUND && obj.userData.sub_type == webcadDefines.ExtrasSubType.GROUND;
    // };

    // // ピン
    // public isPin = (obj: THREE.Object3D) => {
    //     // if (!obj.userData.pinData) return false;
    //     // return obj.userData.pinData && obj.userData.pinData == 'pin';
    //     return this.ModelType(obj) == webcadDefines.ExtrasType.PIN;
    // }

    // private isSelectableItems(object: THREE.Object3D): boolean {
    //     return this.isFurniture(object)
    //         || this.isEquipment(object)
    //         || this.isExterior(object)
    //         || this.isCeillingLight(object)
    //         || this.isFitting(object)
    //         || this.isPin(object);
    // }

    // 対象の家具・住設・外構・ピンを取得
    // public getItem(object: THREE.Object3D) {
    //     if (object == null) return null;
    //     if (object.userData.type) return null; // 家の部品
    //     if (object.userData.modelInfo && !(this.isSelectableItems(object))) return null; // 選択可能アイテム以外は早めにreturn

    //     const index = ThreeView.get().wcItemmgr.furnitureObjects.findIndex((obj) => obj.uuid == object.uuid);
    //     if (index == -1) return this.getItem(object.parent);
    //     return ThreeView.get().wcItemmgr.furnitureObjects[index];
    // }

    // public getFittingItem(object: THREE.Object3D) {
    //     if (object == null || object.userData.type) return null; // 家の部品
    //     if (object.userData.modelInfo && !(this.isSelectableItems(object))) return null; // 選択可能アイテム以外は早めにreturn

    //     const index = ThreeView.get().wcItemmgr.fittings.findIndex((obj) => obj.uuid == object.uuid);
    //     if (index == -1) return this.getFittingItem(object.parent);
    //     return ThreeView.get().wcItemmgr.fittings[index];
    // }

    // 家具・住設・外構・ピンの部品かどうか（選択可能なアイテムか）
    // public isItemSelected(obj: THREE.Object3D): boolean {
    //     const object = this.getItem(obj);
    //     if (object == null) return false;
    //     return this.isSelectableItems(object);
    // }

    // public findObject(groups: THREE.Group[], object: THREE.Object3D) : THREE.Group {
    //     if (object == null || object.userData.type) return null;
    //     if (object.userData.modelInfo && !(this.isSelectableItems(object))) return null; // 選択可能アイテム以外は早めにreturn

    //     const index = groups.findIndex((obj) => obj.uuid == object.uuid);
    //     if (index == -1) return this.findObject(groups, object.parent);
    //     return groups[index];
    // }

    // // 家具・住設・外構・ピンの部品、建具の選択可能なアイテムかの探索を行う
    // // 該当しない場合はnullを返す
    // public selectObject(obj: THREE.Object3D) : THREE.Group {
    //     return this.findObject([...ThreeView.get().wcItemmgr.furnitureObjects, ...ThreeView.get().wcItemmgr.fittings], obj);
    // }
}
